export type ThemeName = 'classic' | 'sophia';

export const DEFAULT_THEME: ThemeName = 'classic';

export const THEME_NAMES: ThemeName[] = ['classic', 'sophia'];

export interface ThemeDefinition {
  // Vuetify palette (applied to `$vuetify.theme`)
  palette: Record<string, string>;
  tabsColor: string;
  tabsSlider: string;
  chartBar: string;
  // Bar colour of the current month in charts (null = same colour for every bar)
  chartHighlight: string | null;
  fontFamily: string;
}

export const THEMES: Record<ThemeName, ThemeDefinition> = {
  // The original Vuetify 1.x look
  classic: {
    palette: {
      primary: '#1976D2',
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107',
    },
    tabsColor: 'cyan',
    tabsSlider: 'yellow',
    chartBar: '#DB4C77',
    chartHighlight: null,
    fontFamily: 'Roboto, sans-serif',
  },
  // Colours and typeface from the Sophia Visual Brand Essentials guide
  sophia: {
    palette: {
      primary: '#003366',
      secondary: '#0062C3',
      accent: '#FF6F3C',
      error: '#BF0000',
      success: '#23BF00',
      warning: '#FFB26B',
      info: '#0062C3',
    },
    tabsColor: 'white',
    tabsSlider: 'accent',
    chartBar: '#003366',
    chartHighlight: '#FF6F3C',
    fontFamily: '\'Funnel Sans\', Roboto, sans-serif',
  },
};
